import apiDashboard from "../ApiDashboard";

const DEFAULT_MESSAGE =
    "Não foi possível realizar essa ação por favor tente mais tarde.";
const URL = "api/campaigns/customer-portfolio/analytic";

export class CampaignsCustomerPortfolioAnalyticService {
    async list(params: any): Promise<any[]> {
        try {
            params.page = params.page || 1;
            const response = await apiDashboard.post(`${URL}`, params);
            return [response?.data, undefined];
        } catch (e: any) {
            return [undefined, DEFAULT_MESSAGE];
        }
    }
    
    async details(params: any): Promise<any[]> {
        try {
            params.page = params.page || 1;
            const response = await apiDashboard.post(`${URL}/details`, params);
            return [response?.data, undefined];
        } catch (e: any) {
            return [undefined, DEFAULT_MESSAGE];
        }
    }
}
